"use strict";

exports.__esModule = true;
/**
	Here we specify where to find the arguments to replace in the loaders int the request.
**/
var dynamicArgumentsMap = exports.dynamicArgumentsMap = {};

var loaders = exports.loaders = [];